import {WebinarAttendanceStatus} from "../webinar-registration/webinar-handler.js";
import {formatDate, formatTime} from "./format-date.js";
const createRecordLink = (record) => {
  const anchor = document.createElement("a");
  anchor.href = record.url;
  if (record.type === "external link") {
    anchor.relList.add("noopener", "noreferrer");
    anchor.target = "_blank";
  }
  return anchor;
};
const renderHeader = (record) => {
  const imageContainer = document.createElement("div");
  imageContainer.classList.add("news-teaser__thumbnail");
  switch (record.type) {
    case "webinar":
      const image = document.createElement("img");
      image.src = record.thumbnail;
      image.loading = "lazy";
      imageContainer.append(image);
      return imageContainer;
    default:
      imageContainer.style.backgroundImage = `url(${record.thumbnail})`;
      const anchor = createRecordLink(record);
      anchor.title = record.title;
      anchor.append(imageContainer);
      return anchor;
  }
};
const renderTitle = (record) => {
  const titleContainer = document.createElement("div");
  titleContainer.classList.add("news-teaser__title");
  const heading = document.createDocumentFragment();
  switch (record.type) {
    case "webinar":
      const titleContainer2 = document.createElement("div");
      titleContainer2.classList.add("margin-bottom--xs");
      const titleHeader = document.createElement("h2");
      titleHeader.classList.add("headline", "headline--1", "color--magenta");
      titleHeader.append(document.createTextNode(record.title));
      titleContainer2.append(titleHeader);
      heading.append(titleContainer2);
      const timeContainer = document.createElement("div");
      timeContainer.classList.add("margin-bottom--xs");
      const timeHeader = document.createElement("h3");
      timeHeader.classList.add("headline", "headline--3");
      timeHeader.append(document.createTextNode(formatDate(record.startDate)), document.createElement("br"), document.createTextNode(formatTime(record.startDate)));
      if (record.endDate) {
        timeHeader.append(document.createTextNode("-"));
        timeHeader.append(document.createTextNode(formatTime(record.endDate)));
      }
      timeContainer.append(timeHeader);
      heading.append(timeContainer);
      break;
    default:
      const header = document.createElement("h3");
      header.classList.add("headline", "headline--2", "headline--title", "margin-bottom--s");
      header.append(document.createTextNode(record.title));
      heading.append(header);
      break;
  }
  if (record.url) {
    const anchor = createRecordLink(record);
    anchor.append(heading);
    titleContainer.append(anchor);
  } else {
    titleContainer.append(heading);
  }
  return titleContainer;
};
const renderTeaser = (record) => {
  const container = document.createElement("div");
  container.classList.add("news-teaser__text", "margin-top--xs");
  container.append(document.createTextNode(record.teaser));
  return container;
};
const renderLink = (record) => {
  const container = document.createElement("div");
  container.classList.add("news-teaser__link", "margin-top--s");
  if (record.url) {
    const anchor = createRecordLink(record);
    anchor.classList.add("text-with-icon", "text-with-icon--large");
    anchor.append(document.createTextNode(record.readMoreLabel));
    container.append(anchor);
  }
  return container;
};
const getUserRegisteredAttribute = (registered) => {
  if (registered === true) {
    return WebinarAttendanceStatus.REGISTERED;
  }
  if (registered === false) {
    return WebinarAttendanceStatus.AVAILABLE;
  }
  return WebinarAttendanceStatus.NOT_AVAILABLE;
};
export const renderNews = (record, registered) => {
  const gridContainer = document.createElement("div");
  gridContainer.classList.add("col-xs-12", "col-sm-6", "col-md-4");
  const root = document.createElement("div");
  root.classList.add("news-teaser", "margin-bottom--s");
  if (record.type === "webinar") {
    root.classList.add("news-teaser--type-webinar");
    root.dataset.uid = record.webinarId.toString();
    root.dataset.userRegistered = getUserRegisteredAttribute(registered);
  } else {
    root.classList.add("background-image--cover");
  }
  if (record.thumbnail) {
    root.append(renderHeader(record));
  }
  const dataContainer = document.createElement("div");
  dataContainer.classList.add("news-teaser__data");
  dataContainer.append(renderTitle(record));
  dataContainer.append(renderTeaser(record));
  dataContainer.append(renderLink(record));
  root.append(dataContainer);
  gridContainer.append(root);
  return gridContainer;
};
